import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Container } from "react-bootstrap";
import { PostData } from "../../services/SendData";
import { getConfigData, removeBaseUrl } from "../../services/Helper";
import BookNowButton from "./../../sections/BookNowButton";
import BreadCrumb from "../BreadCrumb";
import { Helmet } from "react-helmet";

export default function HealthCondition() {
  const configData = getConfigData();
  const { OrganName } = useParams();

  const [seoInfo, setSeoInfo] = useState({ metaDescription: null, pageTitle: null, canonical: null });
  const [testList, setTestList] = useState([]);

  // const apiSegment = "/loadData/submitPage/diagnosisList";
  const apiSegment = "/additionalPageContent/diagnostic-test/" + OrganName;
  const fetchOrganTestList = async () => {
    try {
      // const requestData = {
      //   senddata: {
      //     searchText: `organ|${OrganName}`,
      //     searchType: "null",
      //   },
      // };
      const requestData = {
        DataOnly: 1,
      }
      const response = await PostData(apiSegment, requestData, configData);
      setTestList(response?.data?.data?.services);
      setSeoInfo(response?.data?.seoInfo);
      // console.log(response);


      return false;
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchOrganTestList();
  }, []);

  return (
    <>
      <Helmet>
        {seoInfo?.metaDescription && <meta name="description" content={seoInfo.metaDescription} ></meta>}
        <meta property="og:image" data-rh="true" content={seoInfo?.og_image || 'https://res.genupathlabs.com/genu_path_lab/live/customer_V2/images/genu-logo.png'} />
        <meta name="twitter:card" data-rh="true" content={seoInfo?.og_image || 'https://res.genupathlabs.com/genu_path_lab/live/customer_V2/images/genu-logo.png'} />
        {seoInfo?.pageTitle && <title>{seoInfo?.pageTitle}</title>}
        {seoInfo?.canonical && <link rel="canonical" href={seoInfo?.canonical} />}
      </Helmet>

      <div className="MyProfile">
        <section className="breadcrumb-section">
          <Container>
            <BreadCrumb />
          </Container>
        </section>

        <section className="health-condition-page minheight400">
          <div className="container">
            <h1 className="page-title">Tests by Organ</h1>
            <p>Please select tests to book an appointment</p>

            <div className="health-service-container">
              {testList?.map((test, i) => {
                return (
                  <div className="health-service-card" key={i}>
                    <div>
                      <h2 className="title">
                        <Link to={removeBaseUrl(test?.PermalinkNew || "")}>{test?.ServiceName}</Link>
                        {/* <a target="_self" href={removeBaseUrl(test?.PermalinkNew || "")}>{test?.ServiceName}</a> */}
                      </h2>
                      {test?.ServicePreparation !== null ? (
                        <p className="other-text test-organ">
                          <span>Preparation:</span> {test?.ServicePreparation}
                        </p>
                      ) : null}
                      {test?.ReportPeriod !== null ? (
                        <p className="other-text test-organ">
                          <i className="icon-lab_online_report"></i> <span>Online Report Delivery:</span>{" "}
                          {test?.ReportPeriod === 0
                            ? "Same Day"
                            : `${test?.ReportPeriod} ${test?.ReportPeriod > 1 ? "Days" : "Day"}`}
                        </p>
                      ) : null}
                      {test?.IsHomeCollectionAvailable ? (
                        <p className="other-text test-organ">
                          <i className="icon-home1"></i> <span> Home Collection Available </span>
                        </p>
                      ) : null}
                      {test?.ServiceText ? <p className="other-text test-organ">* {test?.ServiceText}</p> : null}
                    </div>

                    <div className="price-area">
                      <p className="price">₹ {test?.OfferFees}/-</p>

                      <BookNowButton product={test} className="health-service-book" />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
